import Vue from "vue";
import firebase from "firebase";
import store from "./store";
import App from "./App.vue";
import router from "./router";
import vuetify from "vuetify/lib";
import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import JsonCSV from "vue-json-csv";
import JsonExcel from "vue-json-excel";
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import VueGallery from 'vue-gallery'
import moment from 'moment'
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import axios from 'axios'
import VueExcelEditor from 'vue-excel-editor-sae'
import VueMask from 'v-mask'
import i18n from "./i18n";
import * as geolib from 'geolib';
import VueCookie from "vue-cookie";


const getMenuNameByUrl = (key) => {
  switch (key) {
    case '/summary-report':
      return 'Summary Report'
    case '/dashboard':
      return 'Dashboard'
    case '/daily-attendance':
      return 'Daily Attendance'
    case '/user-attendance':
      return 'User Attendance'
    case '/activity-report':
      return 'Activity Report'
    case '/monthly-report':
      return 'Monthly Report'
    case '/user-report':
      return 'User Report'
    case '/issues-report':
      return ' Issue Report'
    case '/employee':
      return 'Employee'
    case '/groups':
      return 'Groups'
    case '/calendar':
      return 'Calendar'
    case '/zones':
      return 'Zones'
    case '/audit-trail':
      return 'Audit Trail'
    case '/approval':
      return 'Approval'
    case '/edit-company':
      return 'Edit Company'
    case '/list-activity':
      return 'List Activity'
    case '/schedule':
      return 'Schedule'
    case '/master-data':
      return 'Master Data'
    case '/issues-attendance':
      return 'Issue Attendance'
    case '/daily':
      return 'Daily Report'
    case '/task-assignment':
      return 'Task Assignment'
    case '/dashboard-attendance':
      return 'Dashboard Attendance'
    case '/maintenance/user-data':
      return 'Admin User Data'
    case '/maintenance/company-data':
      return 'Admin Company Data'
    case '/maintenance/company-config':
      return 'Admin Company Config'
    case '/maintenance/user-analytics':
      return 'Admin User Analytics'
    case '/maintenance/manual-cleansing':
      return 'Admin Manual Cleansing'
    case '/maintenance/dashboards':
      return 'Admin Dashboard'
    case '/maintenance/check-in-history':
      return 'Admin Check in History'
    case '/maintenance/payment':
      return 'Admin Payment'
    case '/login':
      return 'Login'
    case '/news-feed':
      return 'News Feed'
    case '/news-feed-master':
      return 'News Feed Master'
    default:
      return location.pathname
  }
}

axios.interceptors.request.use(
  config => {
    const userId = store.state.user.id
    const menu = getMenuNameByUrl(location.pathname)
    if (!config.url.includes('us-central1-appsensi') && !config.url.includes('maps.googleapis.com') && !config.url.includes('api.verihubs.com')) {
      if (menu) config.headers.common["menu"] = menu
      if (userId) config.headers.common["userId"] = userId
    } else {
      delete config.headers.action
      delete config.headers.actionId
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        if (vnode.context) if (binding.expression) if (vnode.context[binding.expression]) vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

Vue.config.productionTip = false;

const config = {
  apiKey: "AIzaSyAdfU8LnR3fHg7oPVo_mSeUIFjI64Af3YI",
  authDomain: "appsensi-dev.firebaseapp.com",
  databaseURL: "https://appsensi-dev.firebaseio.com",
  projectId: "appsensi-dev",
  storageBucket: "appsensi-dev.appspot.com",
  messagingSenderId: "791004449089",
  appId: "1:791004449089:web:3db08e13911b688d17b9c0"
};

firebase.initializeApp(config);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBVHRqGyv8zxGc4E-H-A77XetsbtwiQC_8",
    region: 'ID',
    language: localStorage.getItem('lang'),
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});
Vue.component("GmapCluster", GmapCluster);
Vue.component("downloadCsv", JsonCSV);
Vue.component("downloadExcel", JsonExcel);
Vue.use(CoolLightBox);
Vue.component('VGallery', VueGallery);
Vue.component('gmap-custom-marker', GmapCustomMarker);

Vue.filter('elipsis', function (value, length) {
  if (!value) return ''
  if (!length) length = 100
  if (value.length > parseInt(length)) {
    value = value.toString().slice(0, parseInt(length))
    return `${value}...`
  } else {
    return value
  }
})

Vue.filter('split', function (value) {
  if (!value) return ''
  return value.split(' ')[0]
})

Vue.filter('hour', function (value) {
  if (!value) return ''
  return moment(value, 'hh:mm:ss').format('HH:mm')
})
Vue.use(VueCookie);
Vue.use(vuetify)
Vue.use(VueExcelEditor)
Vue.use(VueMask)
new Vue({
  store,
  router,
  i18n,
  geolib,
  vuetify: new vuetify(),
  render: h => h(App)
}).$mount("#app");
